const e = (...a) => a.filter(Boolean).join(" ");
export {
  e as default
};
//# sourceMappingURL=classNames.js.map
